export const fetchAwardsData = async () => {
  try {
    const headers = new Headers({
        "cache-control": "max-age=172800"
    })
    const response = await fetch('./content/about/page-components/article/awards.json', {
        headers: headers
    });
    const awards = await response.json();
    return awards;
  } catch (e) {
    console.log(e)
  }
};



// WEBPACK FOOTER //
// ./src/api/fetchAwardsData.js